import { ACTIONABLE, type SyncStatus } from './status.js';

/**
 * What an environment offers without a selection — the same in its two homes, the grid column's
 * kebab and the Environments card: **Push all drift & missing N** and **Inbox N** (the card's
 * **Adopt**, its count already on the card's type rows), both counted across every type. A push
 * is offered only on counts that are current: never after a pull that failed (they are the last
 * good pull's) or before the first one.
 */
export type EnvironmentActions = { actionable: number; inbox: number; canPush: boolean };

export const environmentActions = (
    counts: Partial<Record<SyncStatus, number>> | null,
    pullFailed: boolean,
): EnvironmentActions => {
    const actionable = counts ? ACTIONABLE.reduce((sum, status) => sum + (counts[status] ?? 0), 0) : 0;
    return { actionable, inbox: counts?.env_only ?? 0, canPush: counts !== null && !pullFailed && actionable > 0 };
};
